import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Collapse
} from "@material-ui/core";
import { NavLink, useLocation } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import InventoryIcon from "@mui/icons-material/Inventory";
import { DashboardOutlined } from "@material-ui/icons";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import LayersIcon from '@mui/icons-material/Layers';
import BrushIcon from "@mui/icons-material/Brush";
import GestureIcon from "@mui/icons-material/Gesture";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import WorkIcon from "@mui/icons-material/Work";
import WeekendIcon from "@mui/icons-material/Weekend";
import axios from "axios";
import AuthLoading from "../../Auth/AuthLoading";
import Constants from "../../Variables/Constants";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
const CustomProducts = React.lazy(()=> import("../Custom_Product"));
const Dashboard = React.lazy(() => import("../../Main/Dashboard"));
const UserList = React.lazy(() => import("../../Main/UserList"));
const Subcategory = React.lazy(() => import("../../Main/Subcategory"));
const Fabric = React.lazy(() => import("../../Main/Fabric"));
const FabricType = React.lazy(() => import("../../Main/FabricType"));
const Design = React.lazy(() => import("../../Main/Design"));
const Thread = React.lazy(() => import("../../Main/Thread"));
const Category = React.lazy(() => import("../../Main/Category"));
const Products = React.lazy(() => import("../../Main/Product"));
const Orders = React.lazy(() => import("../../Main/Orders"));
const Size = React.lazy(() => import("../../Main/Size"));
const AddOn = React.lazy(() => import("../../Main/AddOn"));

const Sidebar = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [profileData, setProfileData] = useState({ role: "" });
  const [bagsOpen, setBagsOpen] = useState(true);
  const [pillowsOpen, setPillowsOpen] = useState(true);

  // Helper function to check if a route is active
  const isRouteActive = (routePath) => {
    const currentCategory = new URLSearchParams(location.search).get("category") || "";
    const routeCategory = new URLSearchParams(routePath.split("?")[1] || "").get("category") || null;
    const routePathname = routePath.split("?")[0];
    const currentPathname = location.pathname;

    // Match pathname
    const pathMatches = currentPathname === routePathname || currentPathname === "/" + routePathname;

    // If route has category, also check that it matches
    if (routeCategory) {
      return pathMatches && currentCategory === routeCategory;
    }

    // If route has no category but current URL has one, don't match
    if (!routeCategory && currentCategory) {
      return false;
    }

    return pathMatches;
  };

  const checkAuth = (status) => {
    if (status) {
      setLoading(false);
      setAuthenticated(true);
      getProfile();
    } else {
      setLoading(false);
      setAuthenticated(false);
    }
  };

  const getProfile = async () => {
    try {
      const response = await axios.get(Constants.getUrls.getProfile);
      if (response.data.status === "success") {
        setProfileData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const routes = [
    {
      title: "Dashboard",
      path: "/dashboard",
      component: Dashboard,
      icon: <DashboardOutlined style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "Category",
      path: "/category",
      component: Category,
      icon: <CategoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "Collection",
      path: "/collection",
      component: Subcategory,
      icon: <CollectionsBookmarkIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "Products",
      path: "/products",
      component: Products,
      icon: <InventoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "User List",
      path: "/userList",
      component: UserList,
      icon: <GroupIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "Orders",
      path: "/orders",
      component: Orders,
      icon: <ShoppingCartCheckoutIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: null
    },
    {
      title: "Custom Products",
      path: `/custom-products?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: CustomProducts,
      icon: <InventoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: "Fabric",
      path: `/fabrics?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: Fabric,
      icon: <CheckroomIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: "Fabric Types",
      path: `/fabricTypes?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: FabricType,
      icon: <LayersIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: "Design",
      path: `/design?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: Design,
      icon: <BrushIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: (profileData.role === "admin" || profileData.role === "design_admin"),
      productType: "bag"
    },
    {
      title: "Thread",
      path: `/thread?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: Thread,
      icon: <GestureIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: "Add On",
      path: `/addon?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: AddOn,
      icon: <AddCircleOutlineIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: "Size",
      path: `/size?category=${Constants.categoryNames.TALLIS_TEFILLIN}`,
      component: Size,
      icon: <FormatSizeIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "bag"
    },
    {
      title: " Custom Products",
      path: `/custom-products?category=${Constants.categoryNames.PASSOVER}`,
      component: CustomProducts,
      icon: <InventoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    },
    {
      title: "Fabric",
      path: `/fabrics?category=${Constants.categoryNames.PASSOVER}`,
      component: Fabric,
      icon: <CheckroomIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    },
    {
      title: "Fabric Types",
      path: `/fabricTypes?category=${Constants.categoryNames.PASSOVER}`,
      component: FabricType,
      icon: <LayersIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    },
    {
      title: "Design",
      path: `/design?category=${Constants.categoryNames.PASSOVER}`,
      component: Design,
      icon: <BrushIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: (profileData.role === "admin" || profileData.role === "design_admin"),
      productType: "pillow"
    },
    {
      title: "Thread",
      path: `/thread?category=${Constants.categoryNames.PASSOVER}`,
      component: Thread,
      icon: <GestureIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    },
    {
      title: "Add On",
      path: `/addon?category=${Constants.categoryNames.PASSOVER}`,
      component: AddOn,
      icon: <AddCircleOutlineIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    },
    {
      title: "Size",
      path: `/size?category=${Constants.categoryNames.PASSOVER}`,
      component: Size,
      icon: <FormatSizeIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin",
      productType: "pillow"
    }
  ];

  if (loading) {
    return <AuthLoading checkAuth={checkAuth} />;
  }

  if (!authenticated && !loading) {
    return null;
  }

  const generalRoutes = routes.filter(r => r.isActive && r.productType === null);
  const bagRoutes = routes.filter(r => r.isActive && r.productType === "bag");
  const pillowRoutes = routes.filter(r => r.isActive && r.productType === "pillow");

  return (
    <div
      className="sidebar"
      style={{
        overflowY: "auto",
        height: "100vh",
        boxSizing: "border-box",
        paddingBottom: "60px",
      }}
    >
      <List
        component="nav"
        style={{
          marginTop: "20px",
          paddingBottom: "20px",
        }}
      >
        {/* General Routes */}
        {generalRoutes.map((route, index) => (
          <NavLink
            to={route.path}
            key={`general-${index}`}
            style={{ color: "inherit", textDecoration: "none" }}
            isActive={() => isRouteActive(route.path)}
            activeClassName={"navactive"}
          >
            <ListItem button>
              <ListItemText
                children={
                  <Typography
                    variant={"body2"}
                    style={{ fontSize: 18 }}
                    color="textPrimary"
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ paddingRight: "10px" }}>
                        {route.icon}
                      </span>
                      <span style={{ paddingLeft: "10px" }}>
                        {route.title}
                      </span>
                    </div>
                  </Typography>
                }
                style={{ fontSize: 14 }}
              />
            </ListItem>
          </NavLink>
        ))}

        {/* Tallis/Tefillin Bags Section */}
        {bagRoutes.length > 0 && (
          <>
            <ListItem 
              button 
              onClick={() => setBagsOpen(!bagsOpen)}
              style={{ 
                backgroundColor: bagsOpen ? "rgba(0, 0, 0, 0.04)" : "transparent",
                marginTop: "10px"
              }}
            >
              <ListItemText
                children={
                  <Typography
                    variant={"body2"}
                    style={{ fontSize: 18, fontWeight: 600 }}
                    color="textPrimary"
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ paddingRight: "10px" }}>
                          <WorkIcon style={{ fontSize: "20" }} />
                        </span>
                        <span style={{ paddingLeft: "10px" }}>
                          Tallis/Tefillin Bags
                        </span>
                      </div>
                      {bagsOpen ? <ExpandLess /> : <ExpandMore />}
                    </div>
                  </Typography>
                }
              />
            </ListItem>
            <Collapse in={bagsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {bagRoutes.map((route, index) => (
                  <NavLink
                    to={route.path}
                    key={`bag-${index}`}
                    style={{ color: "inherit", textDecoration: "none" }}
                    isActive={() => isRouteActive(route.path)}
                    activeClassName={"navactive"}
                  >
                    <ListItem button style={{ paddingLeft: "32px" }}>
                      <ListItemText
                        children={
                          <Typography
                            variant={"body2"}
                            style={{ fontSize: 16 }}
                            color="textPrimary"
                          >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span style={{ paddingRight: "10px" }}>
                                {route.icon}
                              </span>
                              <span style={{ paddingLeft: "10px" }}>
                                {route.title}
                              </span>
                            </div>
                          </Typography>
                        }
                      />
                    </ListItem>
                  </NavLink>
                ))}
              </List>
            </Collapse>
          </>
        )}

        {/* Passover Section */}
        {pillowRoutes.length > 0 && (
          <>
            <ListItem 
              button 
              onClick={() => setPillowsOpen(!pillowsOpen)}
              style={{ 
                backgroundColor: pillowsOpen ? "rgba(0, 0, 0, 0.04)" : "transparent",
                marginTop: "10px"
              }}
            >
              <ListItemText
                children={
                  <Typography
                    variant={"body2"}
                    style={{ fontSize: 18, fontWeight: 600 }}
                    color="textPrimary"
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ paddingRight: "10px" }}>
                          <WeekendIcon style={{ fontSize: "20" }} />
                        </span>
                        <span style={{ paddingLeft: "10px" }}>
                          Passover
                        </span>
                      </div>
                      {pillowsOpen ? <ExpandLess /> : <ExpandMore />}
                    </div>
                  </Typography>
                }
              />
            </ListItem>
            <Collapse in={pillowsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {pillowRoutes.map((route, index) => (
                  <NavLink
                    to={route.path}
                    key={`pillow-${index}`}
                    style={{ color: "inherit", textDecoration: "none" }}
                    isActive={() => isRouteActive(route.path)}
                    activeClassName={"navactive"}
                  >
                    <ListItem button style={{ paddingLeft: "32px" }}>
                      <ListItemText
                        children={
                          <Typography
                            variant={"body2"}
                            style={{ fontSize: 16 }}
                            color="textPrimary"
                          >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span style={{ paddingRight: "10px" }}>
                                {route.icon}
                              </span>
                              <span style={{ paddingLeft: "10px" }}>
                                {route.title}
                              </span>
                            </div>
                          </Typography>
                        }
                      />
                    </ListItem>
                  </NavLink>
                ))}
              </List>
            </Collapse>
          </>
        )}
      </List>
    </div>
  );
};

export default Sidebar;
